const moment = require('moment-timezone');

const TimeUtil = {
    getIsoWeekdayArr: () => {
        // Day nubmers use ISO week date format: 1 = Mon, 2 = Tue, ..., 7 = Sun
        // https://en.wikipedia.org/wiki/ISO_week_date
        return [
            {
                isoDayOfWeek: moment().isoWeekday("Sunday").isoWeekday(),
                displayNameShort: 'SUN',
            },
            {
                isoDayOfWeek: moment().isoWeekday("Monday").isoWeekday(),
                displayNameShort: 'MON',
            },
            {
                isoDayOfWeek: moment().isoWeekday("Tuesday").isoWeekday(),
                displayNameShort: 'TUE',
            },
            {
                isoDayOfWeek: moment().isoWeekday("Wednesday").isoWeekday(),
                displayNameShort: 'WED',
            },
            {
                isoDayOfWeek: moment().isoWeekday("Thursday").isoWeekday(),
                displayNameShort: 'THUR',
            },
            {
                isoDayOfWeek: moment().isoWeekday("Friday").isoWeekday(),
                displayNameShort: 'FRI',
            },
            {
                isoDayOfWeek: moment().isoWeekday("Saturday").isoWeekday(),
                displayNameShort: 'SAT',
            },
        ];
    },

    getParsedTimezoneName: (timezoneName, guessIfInvalid=true) => {
        if (!timezoneName) {
        	if (guessIfInvalid) {
                // console.log('getParsedTimezoneName guessing (1)');
	            return moment.tz.guess();
	        }
	        else {
	        	throw new Error('TimeUtil.getParsedTimezoneName(): Invalid timezoneName', timezoneName);
	        }
        }

        const parsedZone = moment.tz.zone(timezoneName);
        if (!parsedZone) {
        	if (guessIfInvalid) {
                // console.log('getParsedTimezoneName guessing (2)');
	            return moment.tz.guess();
	        }
	        else {
	        	throw new Error('TimeUtil.getParsedTimezoneName(): Invalid timezoneName', timezoneName);
	        }
        }

        return parsedZone.name;
    },

    convertDateToUtc: (date) =>  {
        if (!date) {
            return date;
        }

        const m = moment(date);
        return m.utc();
    },
 
    convertToTimeZone: (date, timezoneName) =>  {
        if (!date) {
            return null;
        }

        return moment(date).tz(TimeUtil.getParsedTimezoneName(timezoneName));
    },

    convertTimeToTimeZone: (hour, minute, inTimezoneName, outTimezoneName, referenceDate=moment().format("YYYY-MM-DD HH:mm")) => {
        if (typeof hour !== 'string' || typeof minute !== 'string') {
            return null;
        }

        const date = moment.tz(referenceDate, inTimezoneName).set('hour', hour).set('minute', minute);

        if (inTimezoneName === outTimezoneName) {
            return date;
        }

        return TimeUtil.convertToTimeZone(date, outTimezoneName);
    },

    convertIsoDayToTimezone: (hour, minute, isoDayOfWeek, inTimezoneName, outTimezoneName, referenceDate=moment().format("YYYY-MM-DD HH:mm")) => {
        if (inTimezoneName === outTimezoneName) {
            return isoDayOfWeek;
        }

        const date = moment.tz(referenceDate, inTimezoneName).set('hour', hour).set('minute', minute).isoWeekday(isoDayOfWeek);
        return TimeUtil.convertToTimeZone(date, outTimezoneName).isoWeekday();
    },
};

module.exports = TimeUtil;